import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Row, Col, Card, Form, Input, DatePicker, Select, Button, Switch, Modal, Spin, Checkbox } from 'antd';
import PageTitle from 'shared_components/page_title';
import { SaveOutlined, RollbackOutlined, UserOutlined, ExclamationCircleOutlined, LockOutlined } from '@ant-design/icons'
import { Avatar } from 'antd';
import { formatPhoneNumber, formatMobileNumber } from 'utils/helper';
import Message from 'shared_components/message';
import { fetchUsernameAPI, createUsersAPI, updateUsersAPI } from 'services/users/users';
import {fetchMessageListAPI, fetchRoleListAPI} from 'services/shared/fetchLovList';
import moment from 'moment';
import { RegexInput } from 'shared_components/pattern_input';
import { updatePasssword, user } from 'services/login/login';
import { UserAccessContext } from 'context/userAccess';

const { Option } = Select;
export default function AddUser( props) {
	const { userAccess } = useContext(UserAccessContext);
    const userDetProps = (props.userDetails === 'undefined' ? '' : props.userDetails);
    const navigate = useHistory();
    const [form] = Form.useForm();
    const [ isloading, setLoading ] = useState(true);
    const [roleList, setRolelist] = useState([]);
    const [messagesList, setMessagesList] = useState([]);
    const [ disablePass, setDisablePass ] = useState(true);
    const [ disableConfirmPass, setDisableConfirmPass ] = useState(true);
    const [ resetNewPass, setResetNewPass ] = useState(false);
    const [allDisabled, setAllDisabled] = useState(false);

    const updateUserRight = userAccess['users'].update;

    //handle onchange input of tel_no
    const telNoInput = (e) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        form.setFieldsValue({tel_no: formattedPhoneNumber});
    };

    const mobileNoInput = (e) => {
        const formattedMobileNumber = formatMobileNumber(e.target.value);
        form.setFieldsValue({mobile_no: formattedMobileNumber});
    };



        //get username
        async function getUserName(){
            try {
                const response = await fetchUsernameAPI()
                const name = response[0].user_name;
    
                form.setFieldsValue({user_name: name});
    
            }catch(error) {
                console.log("error", error)
            }
        }
    
        useEffect(()=> {
            if(!props.isEditting){
                getUserName();
                
            }else{
                if(updateUserRight === 'FALSE'){
                    setAllDisabled(true)
                }else{
                    setAllDisabled(false)
                }
            }
            
        }, []);


        const statusOnChange = (checked)=>{
            console.log("status", checked);
        };
    
        const validateMessages = {
            required: 'Field is required.',
            types: {
                email: 'Email is not a valid.',
            },
        };

        useEffect(() => {
            async function fetchData() {
                const rolesList = await fetchRoleListAPI();
                const messages = await fetchMessageListAPI();
                
                setRolelist(rolesList);
                setMessagesList(messages);

                if(messages){
                    setLoading(false);
                };
            }
            fetchData();
        }, []);

        async function handleSubmit(formValues){
            let handleConfirmModal = true
            const newPass = formValues.new_password === undefined ? '' : formValues.new_password
            const confirmPass = formValues.confirm_password === undefined ? '' : formValues.confirm_password

            if(confirmPass === '' && newPass === ''){
                handleConfirmModal = true;
            }else{
                if(confirmPass === ''){
                    // form.setFieldsValue({new_password: undefined})
                    Message.error({ message: 'Please Confirm Password.' });
                    handleConfirmModal = false;
                }

                // const checkCurrentPass = await user(userDetProps.user_id)
                if(newPass !== confirmPass){
                    Message.error({ message: 'The New Password is not the same as the Confirm Password.' });
                    handleConfirmModal = false;
                }

                if(newPass.length < 6 ){
                    const m0023 = messagesList.filter((items) => items.message_code === 'M0023');
                    Message.error({ message: m0023[0].message_display });
                    handleConfirmModal = false;
                }
            }

            if(handleConfirmModal){
                const m0003 = messagesList.filter((items) => items.message_code === 'M0003');
                // call modal
                Modal.confirm({
                    title: m0003[0].message_title,
                    icon: <ExclamationCircleOutlined />,
                    content: m0003[0].message_display,
                    okText: 'YES',
                    cancelText: 'NO',
                    onOk: ()=>{
                        handleConfirm(formValues);
                    }
                });
            }
        };
        
    
        async function handleConfirm(formValues){
            if(!props.isEditting){
                try {
                    const response = await createUsersAPI(formValues);
                    // @ts-ignore
                    if(response.data.user_name !== undefined){
                        const m0017 = messagesList.filter((items) => items.message_code === 'M0017');
                        Message.success({ message: m0017[0].message_display, });
                        navigate.push('/user/search');

                    }else{
                        // @ts-ignore
                        const res = response.data;
                        const resData = res.includes('duplicate key') && res.includes('users_user_name');

                        if(resData){
                            const m0018 = messagesList.filter((items) => items.message_code === 'M0018');
                            Message.success({ message: m0018[0].message_display, });
                        }else{
                            Message.error({ message: res });
                        }
                    }
                
                }catch(error) {
                    console.log("create user error", error)
                    Message.error();
                }
            }else{
                let resetPass = true;
                try {
                    if(resetNewPass){
                        //reset password
                        const res = await updatePasssword(userDetProps.user_id, formValues.new_password)
                        console.log('reset pass new', res);
                        
                        if(!res){
                            resetPass = false;
                            const m0007 = messagesList.filter((items) => items.message_code === 'M0007');
                            Message.success({ message: m0007[0].message_display, });
                        }
                    }

                    if(resetPass){
                        const response = await updateUsersAPI(formValues);
                        // @ts-ignore
                        console.log("response", response.data.user_name)
                        const m0019 = messagesList.filter((items) => items.message_code === 'M0019');
                        Message.success({ message: m0019[0].message_display, });
        
                        navigate.push('/user/search');
                    }
                }catch(error) {
                    console.log("update user error", error)
                    Message.error();
                }
            }
        };

        const roleOptions = roleList.map((item, index) => {
            return (
                <Option key={index} value={item.role_id}>
                    {item.role_name}
                </Option>
            );
        });

        function handleBack(){
            // call modal
            Modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined />,
                content: 'Are you sure you want to cancel? All unsaved details will be discarded.',
                okText: 'YES',
                cancelText: 'NO',
                onOk: ()=>{ navigate.push('/user/search') }
            });
        };

        function onClickResetButton(e){
            const resetButton = e.target.checked
            console.log('reset', resetButton)
            if(resetButton){
                setDisablePass(false)
            }else{
                setDisablePass(true)
                setDisableConfirmPass(true);
                form.setFieldsValue({ new_password:'', confirm_password:'' })
            }
        }

        function onChangeNewPass(e){
            if(e.target.value !== ''){
                setDisableConfirmPass(false);
            }else{
                form.setFieldsValue({confirm_password: ''});
                setDisableConfirmPass(true);
            }
        }

        function onChangeConfirmPass(e){
            if(e.target.value !== ''){
                setResetNewPass(true);
            }else{
                setResetNewPass(false);
            }
        }

    return isloading ? (
        <div className='spin-loading' >
            <Spin tip="Loading..." size='large'></Spin>
        </div>
    ) : (
        <div id='add_users'>
            <Card style={{ padding:"0 80px 0 80px" }}>
                <PageTitle pageTitle="USER DETAILS" />
                <Form layout='vertical'
                    validateMessages={validateMessages}
                    onFinish={handleSubmit}
                    form={form}
                >
                    <Row gutter ={[8 , 1]} justify="end">                        
                        <Col>
                            <Form.Item name="status"  initialValue={(props.isEditting) ? userDetProps.is_active : true}>
                                <Switch checkedChildren='Active' unCheckedChildren='Inactive' onChange={statusOnChange}
                                    defaultChecked={(props.isEditting) ? userDetProps.is_active : true} 
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 1]} align='top'>
                        <Col span={7}>
                            {/* avatar */}
                            <div>
                                <Avatar 
                                    shape="square" 
                                    size={200} 
                                    icon={<UserOutlined />} 
                                    style={{ marginTop:20 }}
                                />
                            </div>
                        </Col>
                        <Col span={17}>
                            {/* user details */}
                            <Row gutter={[8, 1]}>
                                <Col span={8}>
                                    <Form.Item
                                        label='USERNAME'
                                        name="user_name"
                                        rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.user_name : ''}
                                    >
                                        <RegexInput  className='inv-input-uppercase' placeholder='USERNAME' maxLength={20} regex={/^[ A-Za-z0-9_@./-]*$/} 
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='ROLE'
                                        name="role_id"
                                        rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.role_id : ''}
                                    >
                                        <Select placeholder='ROLE' disabled={allDisabled} >
                                        {roleOptions}
                                            
                                        </Select> 
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='POSITION'
                                        name="position"
                                        //rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.position : ''}
                                    >
                                        <Input 
                                        className='inv-input-uppercase'
                                        placeholder='POSITION'
                                        maxLength={50}
                                        disabled={allDisabled}
                                        /> 
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8, 1]}>
                                <Col span={8}>
                                    <Form.Item
                                        label='LAST NAME'
                                        name="last_name"
                                        rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.last_name : ''}
                                    >
                                        <Input type={'text'} 
                                          className='inv-input-uppercase'
                                          placeholder='LAST NAME'
                                          maxLength={50}
                                          disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='FIRST NAME'
                                        name="first_name"
                                        rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.first_name : ''}
                                    >
                                        <Input type={'text'}
                                          className='inv-input-uppercase'
                                          placeholder='FIRST NAME' 
                                          maxLength={50}
                                          disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='MIDDLE NAME'
                                        name="middle_name"
                                       // rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.middle_name : ''}
                                    >
                                        <Input type={'text'}
                                          className='inv-input-uppercase'
                                          placeholder='MIDDLE NAME' 
                                          maxLength={50}
                                          disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8, 1]}>
                                <Col span={4}>
                                    <Form.Item
                                        label='DATE HIRED'
                                        name="date_hired"
                                        //rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? (userDetProps.date_hired === null ? null : moment(userDetProps.date_hired)) : ''}
                                    >
                                        {/* @ts-ignore */}
                                        <DatePicker format={"MM-DD-YYYY"} 
                                        disabledDate={(current) => current.isAfter(moment())}
                                        disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={20}>
                                    <Form.Item
                                        label='ADDRESS'
                                        name="address"
                                        //rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.address : ''}
                                    >
                                        <Input type={'text'}
                                            className='inv-input-uppercase'
                                            placeholder='ADDRESS' 
                                            maxLength={200}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8, 1]}>
                                <Col span={8}>
                                    <Form.Item
                                        label='TEL. NO.'
                                        name="tel_no"
                                        //rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.tel_no : ''}
                                    >
                                        <Input 
                                            placeholder='(632)XXXX-YYYY'
                                            onChange={telNoInput}
                                            maxLength={14}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='MOBILE NO.'
                                        name="mobile_no"
                                        //rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? userDetProps.mobile_no : ''}
                                    >
                                        <Input 
                                            placeholder='(639)XX-XXX-YYYY'
                                            onChange={mobileNoInput}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='EMAIL ADDRESS'
                                        name="email_address"
                                        rules={[ {type: 'email', required: true} ]}
										//rules={[{ type: 'email' , message: 'Not a valid E-mail Address'}]}
                                        initialValue={(props.isEditting) ? userDetProps.email_address : ''}
                                    >
                                        <Input 
                                        placeholder='EMAIL ADDRESS' 
                                        maxLength={50}
                                        disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>                                
                            </Row>
                            {(props.isEditting)
                            ?   
                                <Row gutter={[8, 1]}>
                                    <Col span={8}>
                                        <Form.Item
                                            name="reset_password"
                                            // rules={[ {required: true} ]}
                                        >
                                            <Checkbox style={{float:'right', marginTop: '20px'}} onChange={onClickResetButton} disabled={allDisabled} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label='NEW PASSWORD'
                                            name="new_password"
                                            // rules={[ {required: true} ]}
                                        >
                                            <Input.Password type='password'
                                                placeholder='NEW PASSWORD' 
                                                disabled={disablePass} 
                                                onChange={onChangeNewPass}
                                                disabled={allDisabled}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item
                                            label='CONFIRM PASSWORD'
                                            name="confirm_password"
                                            // rules={[ {required: true} ]}
                                        >
                                            <Input.Password type='password'
                                                placeholder='CONFIRM PASSWORD'
                                                disabled={disableConfirmPass}
                                                onChange={onChangeConfirmPass}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            : <></>
                            }
                        </Col>
                    </Row>
                    {/* buttons */}
                    <Row gutter={[8, 1]} justify='end'>
                        <Col style={{marginTop:50}}>
                            <Form.Item>
                                <Button 
                                    className="inv-button-right" 
                                    type="primary" 
                                    onClick={handleBack}
                                    icon={<RollbackOutlined />}
                                >
                                    BACK
                                </Button>
                                <Button 
                                    className="inv-button" 
                                    type="primary" 
                                    htmlType='submit'
                                    icon={<SaveOutlined />}
                                    disabled={allDisabled}
                                >
                                    SAVE
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
}